import React from 'react';
import PropTypes from 'prop-types';
import phrasesType from '../proptypes/phrases';
import gameResultsAttributesType from '../proptypes/game-results-attributes';
import PageSection from '../design-system/PageSection';
import PageWrapper from '../design-system/PageWrapper';
import ScoreCards from '../components/ScoreCards';
import AccountSubNav from '../components/AccountSubNav';
import NoScores from '../components/NoScores';
import LaserBannerPageSection from '../design-system/LaserBannerPageSection';
import { HeadingSection } from '../design-system/Headings';

const GamesPage = ({
  attributes,
  phrases,
  gamesPath,
  attributesPath,
  specialOpsVideoUrl,
  specialOpsVideoPagePath,
  remainingChallenges,
}) => (
  <PageWrapper tallNav bgDark>
    <AccountSubNav />
    <LaserBannerPageSection>
      <HeadingSection el="h1" my0>{phrases.headings.title}</HeadingSection>
    </LaserBannerPageSection>
    <PageSection bgDarkMid>
      {attributes ? (
        <ScoreCards
          attributes={attributes}
          gamesPath={gamesPath}
          attributesPath={attributesPath}
          specialOpsVideoUrl={specialOpsVideoUrl}
          specialOpsVideoPagePath={specialOpsVideoPagePath}
          remainingChallenges={remainingChallenges}
          phrases={phrases}
        />
      ) : (
        <NoScores phrases={phrases} link={gamesPath} />
      )}
    </PageSection>
  </PageWrapper>
);

GamesPage.defaultProps = {
  remainingChallenges: [],
};

GamesPage.propTypes = {
  attributes: gameResultsAttributesType.isRequired,
  phrases: phrasesType.isRequired,
  gamesPath: PropTypes.string.isRequired,
  attributesPath: PropTypes.string.isRequired,
  specialOpsVideoUrl: PropTypes.string.isRequired,
  specialOpsVideoPagePath: PropTypes.string.isRequired,
  remainingChallenges: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      application: PropTypes.string.isRequired,
      challenge_key: PropTypes.string.isRequired,
    }),
  ),
};

export default GamesPage;
